import axios from 'axios'
import { getToken } from '@/utils/auth'

export function resolveFileDownloadUrl(fileRef) {
  const value = String(fileRef || '').trim()
  if (!value) return ''
  if (/^(https?:|blob:|data:)/i.test(value) || value.includes('/')) return value
  return `${import.meta.env.VITE_APP_BASE_API}/file/download?fileId=${encodeURIComponent(value)}`
}

export function uploadFileRequest(options) {
  const formData = new FormData()
  formData.append(options.filename || 'file', options.file)

  return axios({
    url: import.meta.env.VITE_APP_BASE_API + '/file/upload',
    method: 'post',
    data: formData,
    headers: {
      Authorization: `Bearer ${getToken() || ''}`,
      'Content-Type': 'multipart/form-data'
    },
    onUploadProgress: event => {
      if (event.total && options.onProgress) {
        options.onProgress({ percent: Math.round((event.loaded * 100) / event.total) })
      }
    }
  }).then(response => {
    const data = response.data || {}
    if (data.code !== 200) {
      throw new Error(data.msg || '上传失败')
    }
    options.onSuccess?.(data)
    return data
  }).catch(error => {
    options.onError?.(error)
    throw error
  })
}

export function loadAuthorizedFileBlob(fileRef) {
  const value = String(fileRef || '').trim()
  if (!value) return Promise.reject(new Error('文件标识不能为空'))

  const isExternalUrl = /^https?:/i.test(value)
  const requestConfig = {
    url: resolveFileDownloadUrl(value),
    method: 'get',
    responseType: 'blob'
  }
  // 不向历史外部 URL 透传系统令牌，文件 ID 和站内路径仍携带认证。
  if (!isExternalUrl) {
    requestConfig.headers = { Authorization: `Bearer ${getToken() || ''}` }
  }

  return axios(requestConfig).then(response => {
    const blob = response.data
    if (!(blob instanceof Blob) || blob.size === 0) {
      throw new Error('文件数据无效')
    }
    return blob
  })
}

export function loadAuthorizedFile(fileRef) {
  return loadAuthorizedFileBlob(fileRef).then(blob => {
    if (!(blob instanceof Blob) || !String(blob.type || '').startsWith('image/')) {
      throw new Error('图片数据无效')
    }
    return blob
  })
}

export async function detectPreviewFileKind(blob) {
  const contentType = String(blob?.type || '').split(';')[0].trim().toLowerCase()
  if (contentType === 'application/pdf') return 'pdf'
  if (contentType.startsWith('image/')) return 'image'
  if (!(blob instanceof Blob) || blob.size === 0) return ''

  // 兼容存量文件缺少或错误的 Content-Type。
  const bytes = new Uint8Array(await blob.slice(0, 8).arrayBuffer())
  if (bytes[0] === 0x25 && bytes[1] === 0x50 && bytes[2] === 0x44 && bytes[3] === 0x46) return 'pdf'
  if (bytes[0] === 0x89 && bytes[1] === 0x50 && bytes[2] === 0x4e && bytes[3] === 0x47) return 'image'
  if (bytes[0] === 0xff && bytes[1] === 0xd8 && bytes[2] === 0xff) return 'image'
  if (bytes[0] === 0x47 && bytes[1] === 0x49 && bytes[2] === 0x46 && bytes[3] === 0x38) return 'image'
  if (bytes[0] === 0x42 && bytes[1] === 0x4d) return 'image'
  return ''
}
